/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export enum FeatureTypes {
  SELECT = 1,
  CHECKBOX = 2,
  COLOR = 3,
  RANGE = 4,
  BOOLEAN = 5,
  ICON = 6,
  INTERVAL = 7,
  STRING = 8,
  HTML = 10,
  SIZE = 11,
  LINK = 12,
  DELIMITER = 13,
  SMARTLIST = 14,
}
